import { Link } from '@/i18n/navigation';
import clsx from 'clsx';
import { useTranslations } from 'next-intl';
import Image from 'next/image';
import React from 'react';
import { Button } from '@/components/ui/button';

type Category = {
  href: string;
  name: string;
};
export type CategoryFallbackSelected = {
  selectedCategory?: Category;
  shownCategories: Category[];
};

type Props = {
  selectedCategory?: Category;
  shownCategories: Category[];
};

export const FallbackCategorySelect: React.FC<Props> = ({ selectedCategory, shownCategories }) => {
  const isLong = shownCategories.length > 5;
  const t = useTranslations('filters');
  return (
    <div className='flex flex-col gap-[16px] w-full'>
      {selectedCategory ? (
        <Link href={selectedCategory.href} className='flex gap-[4px] items-center cursor-pointer'>
          {
            <Button variant='ghost' size='icon' className='h-[25px] w-[25px] hover:bg-transparent'>
              <Image src='/assets/icons/arrow-left.svg' height={20} width={20} alt='' />
            </Button>
          }

          <div className='text-[18px] font-semibold'>{selectedCategory.name}</div>
        </Link>
      ) : (
        <div className='text-[18px] font-semibold'>{t('all_categories')}</div>
      )}

      <div
        className={clsx('flex flex-col gap-[2px] h-auto overflow-y-auto scrollbar-thin', {
          'h-auto max-h-[166px]': isLong,
        })}
      >
        {shownCategories.map((item) => (
          <Link
            key={item.href}
            href={item.href}
            className={clsx(
              'flex justify-between items-center cursor-pointer  pl-[16px] py-[10px] max-h-[44px] rounded-[4px]',
              {},
            )}
          >
            <span className='text-text-primary-day text-m font-normal'>{item.name}</span>
          </Link>
        ))}
      </div>
    </div>
  );
};
